const ne = {
  about: {
    desc:
      "हाम्रो उद्देश्य सहज र प्रयोग गर्न सजिलो निःशुल्क एप्लिकेसनहरू विकास गर्नु हो, जसले विभिन्न प्लेटफर्महरूमा कामलाई सजिलो बनाउँछ र उत्पादकता बढाउँछ। हामी गुणस्तर वा प्रयोगकर्ता अनुभवमा सम्झौता नगरी दैनिक जीवनलाई अझ सहज बनाउने उपकरणहरू सिर्जना गर्नेमा विश्वास गर्छौं।",
    title: "हाम्रो बारेमा",
    portfolio: {
      title: "पोर्टफोलियो",
      mpc: {
        name: "म्यारिज पोइन्ट क्याल्कुलेटर",
        desc:
          "🃏 म्यारिज कार्ड गेमको साथीसँगै: म्यारिज पोइन्ट क्याल्कुलेटर (सेन्टर कलेक्शन) मोबाइल एप! प्रयोग गर्न सजिलो र सेयर गर्न मिल्ने इन्टरफेससहित, अब स्कोर गणना सजिलो छ।",
        playStore: "Play Store मा प्राप्त गर्नुहोस्",
        appStore: "Smart TV Store मा प्राप्त गर्नुहोस्",
        web: "वेब एप खोल्नुहोस्",
      },
      led: {
        name: "LED र नियन साइन बोर्ड",
        desc1:
          "तपाईंको डिभाइसलाई डिजिटल साइनबोर्डमा परिणत गर्नुहोस्। तपाईंको स्मार्टफोन, ट्याब्लेट वा स्मार्ट टिभीमा कास्ट गरेर उज्यालो सन्देश देखाउनुहोस्।",
        desc2: "कन्सर्ट र लाइभ इभेन्टका लागि उपयुक्त।",
        playStore: "Play Store मा प्राप्त गर्नुहोस्",
        appStore: "Smart TV Store मा प्राप्त गर्नुहोस्",
        web: "वेब एप खोल्नुहोस्",
      },
      tax: {
        name: "ट्याक्स एडभाइजर नेपाल",
        desc:
          "आफ्नो कर गणना गर्नुहोस् र कसरी बचत गर्ने उपायहरू पत्ता लगाउनुहोस्।",
        web: "वेब एप खोल्नुहोस्",
      },
      installOnMobile: "इन्स्टल",
      openWebApp: "वेब एप खोल्नुहोस्",
    },
    team: {
      title: "हाम्रो टोली",
      manoj: {
        name: "मनोज श्रेष्ठ",
        role: "मुख्य कार्यकारी अधिकृत (CEO)",
        desc:
          "१० वर्षभन्दा बढीको अनुभव भएका IT व्यवसाय विज्ञ। IT को माध्यमबाट व्यापार समस्या समाधान गर्नमा विशेष दक्षता।",
        profile: "प्रोफाइल हेर्नुहोस्",
      },
      pujan: {
        name: "पुजन श्रेष्ठ",
        role: "मुख्य प्राविधिक अधिकृत (CTO)",
        desc:
          "७ वर्षभन्दा बढी अनुभव भएका प्रविधि विशेषज्ञ। कम्पनीको सम्पूर्ण प्राविधिक पक्ष सम्हाल्नुहुन्छ र पूर्ण स्ट्याक विकासमा दक्ष।",
        profile: "प्रोफाइल हेर्नुहोस्",
      },
      learnMore: "थप जान्नुहोस्",
    },

    description:
      "हाम्रो एपमा स्वागत छ! हामी तपाईंलाई उत्कृष्ट अनुभव दिन चाहन्छौं।",
  },
  share: {
    title: "सेयर गर्नुहोस्",
    description:
      "एप इन्स्टल गर्न तपाईंको साथीलाई QR कोड स्क्यान गर्न भन्नुहोस्!",
  },
  privacy: {
    title: "गोपनीयता नीति",
    date: "जनवरी १, २०२४",
    description: "हाम्रो एप प्रयोग गर्नु भएकोमा धन्यवाद। तपाईंको गोपनीयता हाम्रो लागि महत्त्वपूर्ण छ। यो गोपनीयता नीतिले हामीले जानकारी कसरी संकलन, प्रयोग र सुरक्षित गर्छौं भन्ने कुरा स्पष्ट पार्दछ।",
    sections: {
      1: {
        title: "हामीले संकलन गर्ने जानकारी",
        body: "व्यक्तिगत जानकारी: तपाईंले स्वेच्छाले प्रदान गर्नुभएको खण्डमा, तपाईंको नाम, इमेल ठेगाना वा अन्य सम्पर्क विवरणहरू संकलन गर्न सक्छौं।\n\nप्रयोग डेटा: तपाईंले एपमा कुन पेज हेर्नुभयो, कुन फिचर प्रयोग गर्नुभयो आदि जानकारी संकलन गर्छौं।\n\nडिभाइस जानकारी: प्रदर्शन र समस्या समाधानका लागि तपाईंको डिभाइस प्रकार, अपरेटिङ सिस्टम, एप संस्करण आदि संकलन गर्न सक्छौं।"
      },
      2: {
        title: "जानकारीको प्रयोग",
        body: "हाम्रो सेवा प्रदान गर्न र सुधार गर्न।\n\nप्रयोगकर्ता अनुभवलाई व्यक्तिगत बनाउन।\n\nतपाईंका जिज्ञासा वा सहयोगका लागि प्रतिक्रिया दिन।\n\nमहत्त्वपूर्ण सूचना वा प्रचारात्मक सन्देश (केवल तपाईंको सहमतिमा) पठाउन।"
      },
      3: {
        title: "जानकारीको साझेदारी",
        body: "हामी तपाईंको व्यक्तिगत जानकारी बिक्री गर्दैनौं। हामीले जानकारी साझेदारी गर्न सक्छौं:\n\nएप सञ्चालनमा सहयोग गर्ने भरपर्दो तेस्रो पक्ष सेवासँग।\n\nकानूनी आवश्यकता वा हाम्रा अधिकारको रक्षा गर्न।"
      },
      4: {
        title: "डाटा सुरक्षा",
        body: "अनधिकृत पहुँच, हराउने वा दुरुपयोगबाट तपाईंको डाटालाई जोगाउन उपयुक्त प्राविधिक तथा व्यवस्थापकीय उपायहरू अपनाएका छौं।"
      },
      5: {
        title: "तपाईंका अधिकारहरू",
        body: "तपाईंलाई निम्न अधिकारहरू छन्:\n\nहामीसँग रहेको जानकारीमा पहुँच।\n\nसुधार वा मेटाउन अनुरोध गर्न।\n\nकुनै पनि बेला सहमति फिर्ता लिन।"
      },
      6: {
        title: "तेस्रो पक्ष सेवा",
        body: "हाम्रो एपले तेस्रो पक्ष सेवा (जस्तै: एनालिटिक्स वा विज्ञापन) प्रयोग गर्न सक्छ, जसका आफ्नै गोपनीयता नीति छन्। ती नीतिहरू पनि हेर्न सल्लाह दिन्छौं।"
      },
      7: {
        title: "नीति परिवर्तन",
        body: "हामी समयसमयमा यो नीति अद्यावधिक गर्न सक्छौं। परिवर्तनहरू एपमा नयाँ मितिसहित पोस्ट गरिनेछ।"
      },
      8: {
        title: "सम्पर्क गर्नुहोस्",
        body: "यदि तपाईंलाई यस नीतिबारे कुनै प्रश्न वा चिन्ता छ भने, कृपया shrestha.applications@gmail.com मा सम्पर्क गर्नुहोस्।"
      }
    }
  },
  terms: {
    title: "प्रयोगका सर्तहरू",
    description: "कृपया प्रयोग गर्नु अघि सर्तहरू ध्यानपूर्वक पढ्नुहोस्।",
    sections: {
      1: {
        title: "सर्तहरूको स्वीकृति",
        body:
          "यस एप्लिकेसनमा पहुँच वा प्रयोग गर्दा, तपाईं यी सर्तहरूमा सहमत हुनुहुन्छ।",
      },
      2: {
        title: "सर्तहरूको परिमार्जन",
        body:
          "हामी कुनै पनि समयमा यी सर्तहरू परिवर्तन, परिमार्जन वा संशोधन गर्ने अधिकार राख्छौं। परिवर्तनपछि एप प्रयोग गर्नु भनेको नयाँ सर्तहरूमा तपाईंको सहमति हो।",
      },
      3: {
        title: "प्रयोगकर्ताको जिम्मेवारी",
        body:
          "तपाईंले एपलाई कानूनी प्रयोजनका लागि मात्र प्रयोग गर्ने र एप वा यसको प्रयोगकर्तालाई हानि पुर्‍याउने कुनै पनि गतिविधिमा संलग्न नहुने सहमति गर्नुहुन्छ।",
      },
      4: {
        title: "बौद्धिक सम्पत्ति",
        body:
          "यस एपका सबै सामग्री, सुविधाहरू र कार्यक्षमता Shrestha Apps को स्वामित्वमा छन् र प्रतिलिपि अधिकार तथा अन्य कानुनद्वारा सुरक्षित छन्।",
      },
      5: {
        title: "तेस्रो-पक्ष सेवा",
        body:
          "एपमा तेस्रो-पक्ष वेबसाइट वा सेवाहरूको लिंक हुन सक्छ, जसको नियन्त्रण हामीसँग छैन। तेस्रो-पक्ष साइटको सामग्री वा अभ्यासका लागि हामी जिम्मेवार छैनौं।",
      },
      6: {
        title: "वारेन्टी अस्वीकरण",
        body:
          "एप 'जस्ताको तस्तै' र 'उपलब्ध भए अनुसार' प्रदान गरिन्छ। हामी एपको सञ्चालन वा उपलब्धताका लागि कुनै वारेन्टी दिन्नौं।",
      },
      7: {
        title: "दायित्वको सीमा",
        body:
          "Shrestha Apps कुनै पनि क्षतिको लागि जिम्मेवार हुने छैन, जुन तपाईंको एप प्रयोगसँग सम्बन्धित छ।",
      },
      8: {
        title: "क्षतिपूर्ति",
        body:
          "एप प्रयोग गर्दा उत्पन्न हुने कुनै पनि दाबी, क्षति वा खर्चको लागि तपाईंले Shrestha Apps लाई क्षतिपूर्ति दिने सहमति गर्नुहुन्छ।",
      },
      9: {
        title: "समाप्ति",
        body:
          "हामी कुनै पनि बेला, कुनै पनि कारणले, बिना सूचना तपाईंको एप पहुँच निलम्बन वा समाप्त गर्ने अधिकार राख्छौं।",
      },
      10: {
        title: "लागू कानून",
        body: "यी सर्तहरू नेपालका कानून अनुसार लागू हुनेछन्।",
      },
      11: {
        title: "सम्पर्क गर्नुहोस्",
        body:
          "यी सर्तहरूबारे कुनै प्रश्न छ भने, कृपया shresthaapps@gmail.com मा सम्पर्क गर्नुहोस्।",
      },
      12: {
        title: "सम्पूर्ण सम्झौता",
        body:
          "यी सर्तहरूले एप प्रयोगसम्बन्धी तपाईं र Shrestha Apps बीचको सम्पूर्ण सम्झौता बनाउँछ।",
      },
    },
  },
  footer: {
    copyright: "© {year} श्रेष्ठ एप्स",
    allRightsReserved: "सबै अधिकार सुरक्षित",
    tagline: "हामी तपाईंको जीवनलाई अझ सहज बनाउन एपहरू बनाउँछौं।",
    nepal: "नेपाल",
    japan: "जापान",
    usa: "अमेरिका",
    email: "इमेल",
  },
};

export default ne;
